module.exports = __webpack_public_path__ + "img/logo-footer.37667849.svg";